/* Playing Cards sidebar layout (sections/ip-groups.liquid, layout "sidebar").
   A group link filters the one deck grid; the choice lives in the URL hash so
   it can be linked to and survives Back. Sort reorders the same tiles. */
(function () {
  function init(root) {
    var grid = root.querySelector('[data-ipgrid]');
    var cells = Array.prototype.slice.call(grid.children);
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-ipfilter]'));
    var count = root.querySelector('[data-ipcount]');
    var sort = root.querySelector('[data-ipsort]');
    var keys = links.map(function (a) { return a.dataset.ipfilter; });

    function apply(key, scroll) {
      if (keys.indexOf(key) < 0) key = 'all';
      var shown = 0;
      cells.forEach(function (c) {
        var on = key === 'all' || c.dataset.groups.indexOf(' ' + key + ' ') > -1;
        c.hidden = !on;
        /* A deck set (bundle) shows but is not counted as an item. */
        if (on && !c.hasAttribute('data-bundle')) shown++;
      });
      links.forEach(function (a) {
        if (a.dataset.ipfilter === key) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      var label = links.filter(function (a) { return a.dataset.ipfilter === key; })[0];
      var name = key === 'all' ? '' : ' in ' + (label.dataset.label || label.firstChild.textContent.trim());
      count.textContent = shown + (shown === 1 ? ' deck' : ' decks') + name;
      /* Keep the chosen pill in view on the phone's sideways row. */
      if (label && label.scrollIntoView && window.innerWidth < 1080) {
        label.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      if (scroll) {
        var top = root.querySelector('.ipside__main').getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function fromHash(scroll) {
      apply(decodeURIComponent((location.hash || '#all').slice(1)), scroll);
    }

    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var key = a.dataset.ipfilter;
        /* replaceState, not a jump: the hash names a group, not an anchor. */
        history.pushState(null, '', key === 'all' ? location.pathname + location.search : '#' + key);
        apply(key, true);
      });
    });
    window.addEventListener('popstate', function () { fromHash(false); });

    if (sort) sort.addEventListener('change', function () {
      var v = sort.value;
      cells.slice().sort(function (a, b) {
        if (v === 'new') return b.dataset.created - a.dataset.created;
        if (v === 'price-asc') return a.dataset.price - b.dataset.price || a.dataset.order - b.dataset.order;
        if (v === 'price-desc') return b.dataset.price - a.dataset.price || a.dataset.order - b.dataset.order;
        if (v === 'name') return a.dataset.name.localeCompare(b.dataset.name);
        return a.dataset.order - b.dataset.order;
      }).forEach(function (c) { grid.appendChild(c); });
    });

    fromHash(false);
  }

  function boot() { document.querySelectorAll('[data-ipside]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
